import { render } from "./EventTickets.vue?vue&type=template&id=ad775b42"
import script from "./EventTickets.vue?vue&type=script&lang=js"
export * from "./EventTickets.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__